import { connect } from 'react-redux';
import { stopPlaying, playStimulusAudio } from '../../stimulus/stimulusButtonActions';
import StimulusButton from '../../stimulus/StimulusButton';
import { blockScreen, unblockScreen } from '../../screen/screenActions';
import selectors from '../../../rootSelectors';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';

const mapStateToProps = (state) => ({
    isPlaying: selectors.getIsStimulusPlaying(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    stopPlaying: () => {
        dispatch(stopPlaying());
    },
    onClick: () => {
        const delay = GENERAL_AUDIO_DELAY;
        dispatch(blockScreen());
        return dispatch(playStimulusAudio(ownProps.audioTracks, delay))
            .then(() => { dispatch(unblockScreen()); });
    },
});

const ComprehensionStimulusContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(StimulusButton);

export default ComprehensionStimulusContainer;
